import { defineComponent as _defineComponent } from 'vue'
import MapRoutes from '../../map/MapRoutes.vue'
import MapDefaultMarker from '@/components/core/map/MapDefaultMarker.vue'
import MapView from '@/components/core/map/MapView.vue'
import { useSelectedTrip } from '@/composables/trip'


export default /*#__PURE__*/_defineComponent({
  __name: 'TransportationSlideOverMap',
  setup(__props) {

const trip = useSelectedTrip()

return { __sfc: true,trip, MapRoutes, MapDefaultMarker, MapView }
}

})